<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.billing && source">
    <div *ngIf="tabs && tabs.length > 0" class="freeze_height">
        <div class="freeze_height" style="text-align: right;">
            <div style="width: fit-content;background-color: aliceblue;float: right;margin-top: 10px;">
                <button class="button_icon button_icon_color" [ngClass]="isGridView ? 'active' :''"
                    (click)="onAction(7)">
                    grid_view
                </button>
                <button class="button_icon button_icon_color" [ngClass]="isGridView ? '' :'active'"
                    (click)="onAction(8)">
                    list_alt
                </button>
            </div>
        </div>
        <app-tab [tabs]="tabs" [(selectedKey)]="selectedTabKey" [isShowRefresh]="true" (onRefresh)="onLoad()"
            (onTabSelected)="onSetFilterReplaceOption()" />
    </div>
    <div style="margin: 10px;" class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
        <div *ngIf="source && source.items.length == 0" class="center">
            {{localService.languageContent.common.no_data}}
        </div>
        <div *ngIf="source && source.items.length > 0" [ngStyle]="{'margin-left' : marginLeft + 'px'}"
            [ngClass]="isGridView ? 'compact_quick_pick_mode_container' : 'compact_quick_pick_mode_container_list_view'">
            <ng-container *ngFor="let item of source.items; index as idx">
                <div class="compact_quick_pick_mode banner" *ngIf="item.isPinned 
                && item.printerTemplateId == selectedTabKey
                && (searchKey.length == 0 
                    || (item.displayName ? item.displayName.toLowerCase().indexOf(searchKey.toLowerCase()) >-1 
                    : item.title.toLowerCase().indexOf(searchKey.toLowerCase()) >-1))">
                    <div class="row">
                        <div class="col-12">
                            <div title="{{item.title}}">
                                <label style="font-weight: normal; margin-left: 15px;">
                                    <input type="checkbox" [(ngModel)]="item.isSelected" (change)="onSave()" />
                                    <span>
                                        {{item.displayName ? item.displayName : item.title}}
                                        <span class="en order_nbr">&nbsp;({{item.orderNumber}})</span>
                                    </span>
                                </label>
                            </div>
                            <div *ngIf="item.receiptOption && item.receiptOption > 0 && !item.isEditable">
                                <span style="font-style: italic;">
                                    <{{localService.getText(receiptOptions,item.receiptOption)}}>
                                </span>
                            </div>
                            <div *ngIf="item.isAutoIncreaseValue">
                                <span style="font-style: italic;">{{item.value}}</span>
                            </div>
                            <div
                                *ngIf="(!item.receiptOption || item.receiptOption == 0 || item.isEditable) && !item.isAutoIncreaseValue">
                                <div
                                    *ngIf="item.customLabelInputType == CustomLabelInputType.SingleInputBox.toString()">
                                    <input autocomplete="off" type="text" style="margin-bottom: 10px;"
                                        (blur)="onSave(true, item.key)" [(ngModel)]="item.value"
                                        title="{{localService.languageContent.common.value}}"
                                        id="{{elementIds.value + idx}}"
                                        [disabled]="isLockFieldsIfAccepted && !isDraftMode"
                                        placeholder="{{localService.languageContent.common.value}}" />
                                </div>
                                <div
                                    *ngIf="item.customLabelInputType == CustomLabelInputType.MultiLineInputBox.toString()">
                                    <textarea id="{{elementIds.value + idx}}" rows="5" [(ngModel)]="item.value"
                                        [disabled]="isLockFieldsIfAccepted && !isDraftMode"
                                        title="{{localService.languageContent.common.value}}"
                                        (blur)="onSave(true, item.key)"
                                        placeholder="{{localService.languageContent.common.value}}"></textarea>
                                </div>
                                <div *ngIf="item.customLabelInputType == CustomLabelInputType.SingleSelect.toString()
                                    || item.customLabelInputType == CustomLabelInputType.MultiSelect.toString()">
                                    <app-list-options [items]="item.selectedOptions" [isRemoveRequired]="true"
                                        [isMultiSelect]="item.customLabelInputType == CustomLabelInputType.MultiSelect.toString()"
                                        (onSelectionChanged)="onSelectionChanged($event,item.customLabelInputType == CustomLabelInputType.MultiSelect.toString(),item.key)"
                                        [isDisabled]="isLockFieldsIfAccepted && !isDraftMode"
                                        (onSelectionRemoved)="onSelectionRemoved($event,item.customLabelInputType == CustomLabelInputType.MultiSelect.toString(),item.key)" />
                                </div>
                                <div
                                    *ngIf="item.customLabelInputType == CustomLabelInputType.SingleSelectDropdown.toString()">
                                    <ngx-select [(ngModel)]="item.value" [noAutoComplete]="false"
                                        [disabled]="isLockFieldsIfAccepted && !isDraftMode"
                                        [items]="item.selectedOptions" [optionValueField]="'key'"
                                        [placeholder]="localService.languageContent.common.value"
                                        [optionTextField]="'value'" (select)="onSave(true, item.key)" appendTo="body">
                                    </ngx-select>
                                </div>
                                <div *ngIf="item.customLabelInputType == CustomLabelInputType.ImageUpload.toString()">
                                    <div class="center" style="text-align: center;">
                                        <button class="button_icon button_icon_color icon_adjust"
                                            *ngIf="!(item.value && item.value.length > 0)"
                                            (click)="onAction(9,item.key)"
                                            [disabled]="isLockFieldsIfAccepted && !isDraftMode"
                                            title="{{localService.languageContent.common.value}}">
                                            photo_camera
                                        </button>
                                        <button class=" button_link link_btn" (click)="onAction(9,item.key)"
                                            *ngIf="item.value && item.value.length > 0">
                                            <div class="btn_option" style="display: inline-grid;">
                                                <img src="{{item.value}}" style="height: 100%;width: 100%;"
                                                    alt="Image Preview" />
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                <div
                                    *ngIf="item.customLabelInputType == CustomLabelInputType.HourOrDayInput.toString()">
                                    <div style="display: inline-flex;">
                                        <div style="width: 70px;">
                                            <input autocomplete="off" type="text" style="margin-bottom: 10px;"
                                                (blur)="onSave(true, item.key)" [(ngModel)]="item.value"
                                                title="{{localService.languageContent.common.value}}"
                                                id="{{elementIds.value + idx}}"
                                                [disabled]="isLockFieldsIfAccepted && !isDraftMode"
                                                placeholder="{{localService.languageContent.common.value}}" />
                                        </div>
                                        <div>
                                            <button class=" button_link link_btn" (click)="onSetHoursDay(1,item.key)">
                                                <div class="btn_option">
                                                    <i class="material-icons menu_icon icon_adjust">
                                                        {{!isEndsWitDay(item.value) ? 'radio_button_checked' :
                                                        'radio_button_unchecked'}}
                                                    </i>
                                                    <span>{{localService.languageContent.billing.hour}}</span>
                                                </div>
                                            </button>
                                            <button class=" button_link link_btn" (click)="onSetHoursDay(2,item.key)">
                                                <div class="btn_option">
                                                    <i class="material-icons menu_icon icon_adjust">
                                                        {{isEndsWitDay(item.value) ? 'radio_button_checked' :
                                                        'radio_button_unchecked'}}
                                                    </i>
                                                    <span>{{localService.languageContent.billing.day}}</span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="freeze_height footer" *ngIf="isShowOnlyAcceptAndPrintButtonInCustomReceiptPage">
        <div class="row">
            <div class="col-12">
                <button class=" btn btn-primary" *ngIf="!(source.content.v1?.length > 0)" id="{{elementIds.btn_accept}}"
                    [disabled]="!(billingId?.length > 5)" (click)="onUpdateStatus(3)">
                    {{localService.languageContent.billing.accept}}
                    <span class="en">&nbsp;&&nbsp;</span>
                    {{localService.languageContent.billing.print}}
                </button>
                <button class="button_icon button_icon_color action-btn" [disabled]="!(source.content.v1?.length > 0)"
                    (click)="onPrint()" style="top: 3px;">
                    print
                </button>
            </div>
        </div>
    </div>
    <div class="freeze_height footer" *ngIf="!isShowOnlyAcceptAndPrintButtonInCustomReceiptPage">
        <div class="row">
            <div [ngClass]="isFooterbarShow ? 'col-md-3' : 'col-1'">
                <button class="button_icon button_icon_color" style="top: 3px;left: -5px;"
                    [ngClass]="isFooterbarShow ? 'arrow_right' : 'arrow_left'"
                    (click)="isFooterbarShow = !isFooterbarShow;" id="{{elementIds.show_more}}">
                    double_arrow
                </button>
                <div style="display: flex;">
                    <button class="btn btn-primary" id="{{elementIds.btn_paid}}"
                        *ngIf="isFooterbarShow && source.content.v3 == '0'" (click)="isOpenPaymentModes = true;">
                        {{localService.languageContent.billing.paid}}
                    </button>
                    <button class=" btn btn-primary" id="{{elementIds.btn_accept}}"
                        *ngIf="isFooterbarShow && !(source.content.v1?.length > 0)" (click)="onUpdateStatus(3)">
                        {{localService.languageContent.billing.accept}}
                    </button>
                    <app-business-relationship [id]="elementIds.brn_search_billing_customer" *ngIf="isFooterbarShow"
                        [isMultiCustomerTypes]="true" [businessId]="businessId" [currentUserId]="source.content.v4"
                        (onUserUpdated)="onUserUpdated(1,$event)" [relationShipType]="relationShipType"
                        [relationShipRole]="3" />
                </div>
            </div>
            <div class="col-md-5" *ngIf="isFooterbarShow">
                <div class="row">
                    <div class="col-md-4">
                        <ngx-select [(ngModel)]="selectedLanguageId" [noAutoComplete]="true" class="footer_dd"
                            [items]="localService.languagesEquivalent" [optionValueField]="'v1'"
                            [optionTextField]="'v3'" (select)="onLoad()">
                        </ngx-select>
                    </div>
                    <div class="col-md-8">
                        <div *ngIf="!isShowSaveAs">
                            <div class="row">
                                <div class="col-md-6">
                                    <ngx-select [isFocused]="true" [id]="elementIds.dd_language" class="footer_dd"
                                        [disabled]="!(savedCustomLabels && savedCustomLabels.length > 0)"
                                        [(ngModel)]="selectedSavedCustomLabelId" [noAutoComplete]="true"
                                        [items]="savedCustomLabels" [optionValueField]="'key'" [optionTextField]="'v2'"
                                        (select)="onFillFromSavedCustomLabels()" [noAutoComplete]="false"
                                        [allowClear]="true" [disabled]="isLockFieldsIfAccepted && !isDraftMode"
                                        placeholder="{{localService.languageContent.billing.get_saved_custom_label}}">
                                        <ng-template ngx-select-option-selected ngx-select-option let-option
                                            let-text="text">
                                            <div class="row" title="{{option.data.v3}}">
                                                <div class="col-md-12">
                                                    <span>{{option.data.v1}}</span>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </ngx-select>
                                </div>
                                <div class="col-md-6">
                                    <button id="{{elementIds.save_as}}" type="button" class="btn btn-primary wrap-div"
                                        (click)="onAction(2)">
                                        <span>
                                            {{localService.languageContent.billing.save_as_custom_label}}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isShowSaveAs">
                            <div class="row">
                                <div class="col-md-6">
                                    <input autocomplete="off" type="text" [(ngModel)]="titleToSave"
                                        id="{{elementIds.txt_title}}"
                                        title="{{localService.languageContent.table.title}}"
                                        placeholder="{{localService.languageContent.table.title}}"
                                        (keyup)="onCheckNewTitle()" />
                                </div>
                                <div class="col-md-3" style="text-align: center;">
                                    <button id="{{elementIds.cancel}}" type="button" class="btn btn-primary"
                                        (click)="onAction(3)">
                                        <span>
                                            {{localService.languageContent.common.cancel}}
                                        </span>
                                    </button>
                                </div>
                                <div class="col-md-3" style="text-align: center;">
                                    <button id="{{elementIds.create}}" type="button" class="btn btn-primary"
                                        [disabled]="!(titleToSave && titleToSave.trim().length > 0)"
                                        (click)="onAction(4)">
                                        <span>
                                            {{isNewTitle ? localService.languageContent.common.create :
                                            localService.languageContent.common.update}}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div [ngClass]="isFooterbarShow ? 'col-md-4' : 'col-11'">
                <div style="margin-left: 10px;">
                    <input autocomplete="off" type="text" [(ngModel)]="searchKey" style="width: calc(100% - 160px);"
                        title="{{localService.languageContent.common.search}}"
                        placeholder="{{localService.languageContent.common.search}}" />
                    <button [id]="elementIds.btn_clear" class="button_icon icon_adjust" style="color: red !important;"
                        (click)="onAction(5)" title="{{localService.languageContent.billing.clear_custom_label}}"
                        [disabled]="isLockFieldsIfAccepted && !isDraftMode">
                        clear_all
                    </button>
                    <button class="button_icon button_icon_color action-btn" (click)="onSendToPhone()"
                        [disabled]="!isShowSendToPhone" style="top: 3px;"
                        title="{{localService.languageContent.common.send_to_phone}}">
                        send_to_mobile
                    </button>
                    <button class="button_icon button_icon_color action-btn" (click)="onPrint()" style="top: 3px;">
                        print
                    </button>
                    <button class="button_icon button_icon_color action-btn" (click)="onAction(6)" style="top: 3px;">
                        receipt
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div>
        <app-bill-payment-types [(isOpenPopup)]="isOpenPaymentModes" [paymentMethods]="source.paymentMethods"
            [billAmount]="total" [businessId]="businessId" [receiptId]="billingId" [isPaid]="false"
            (onPaid)="onPaid($event)" [isShowPayAndPrint]="isPrintOncePaid"
            [isShowPayAndSendToPhone]="isShowSendToPhone" />
        <app-send-to-phone *ngIf="isOpenSendToPhone" [(isOpen)]="isOpenSendToPhone" [isHiddenProcess]="false"
            [key]="billingId" [communicationTemplate]="CommunicationTemplate.SendBillToPhone"
            [returnDataOnSuccess]="null" />
        <app-print-receipt *ngIf="isPrint" [receiptId]="billingId" [IsPrint]="isPrint" [isForBusiness]="true"
            (onPrinted)="onPrinted()" [printingLanguageId]="selectedLanguageId" [businessId]="businessId"
            [interactionType]="interactionType" />
        <app-capture-photo *ngIf="isOpenCamera" [key]="selectedId" (onCaptured)="onCaptured($event)"
            (onClose)="isOpenCamera = false" />
    </div>
</div>